import { MouseEvent } from 'react';

import TooltipWrapper from 'approot/shared/tooltip/tooltip-wrapper';
import IconExpand from 'approot/shared/icons/icon-expand';
import { SecondaryButtonIconLink } from 'approot/shared/styles/buttons/secondary-button.style';

type Props = {
  link: string;
  ariaLabel: string;
  isSmall?: boolean;
  onLinkClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
};

const ExpandButton = ({ link, ariaLabel, isSmall, onLinkClick }: Props) => {
  return (
    <TooltipWrapper hoverText="Expand">
      <SecondaryButtonIconLink
        to={link}
        data-selector="expand"
        aria-label={ariaLabel}
        $borderRadius={8}
        $isSmall={isSmall}
        onClick={onLinkClick}
      >
        <IconExpand width={20} height={20} />
      </SecondaryButtonIconLink>
    </TooltipWrapper>
  );
};

export default ExpandButton;
